import { styled } from "styled-components";

import { PanelBlock } from "../../../../../layout/MainPanel/PanelBlock";

export const StyledSummaryInfoBlock = styled(PanelBlock)`
  gap: 8px;
`;
